import { render, staticRenderFns } from "./DedicatePage1.vue?vue&type=template&id=8e55ab56&scoped=true&"
import script from "./DedicatePage1.vue?vue&type=script&lang=js&"
export * from "./DedicatePage1.vue?vue&type=script&lang=js&"
import style0 from "./DedicatePage1.vue?vue&type=style&index=0&id=8e55ab56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e55ab56",
  null
  
)

export default component.exports